import { render, staticRenderFns } from "./VendorApprovalPage.vue?vue&type=template&id=4be4c5e8&"
import script from "./VendorApprovalPage.vue?vue&type=script&lang=js&"
export * from "./VendorApprovalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports